import { render, staticRenderFns } from "./QCreateSupportTicket.vue?vue&type=template&id=14d09070&scoped=true&"
import script from "./QCreateSupportTicket.vue?vue&type=script&lang=js&"
export * from "./QCreateSupportTicket.vue?vue&type=script&lang=js&"
import style0 from "./QCreateSupportTicket.vue?vue&type=style&index=0&id=14d09070&prod&scoped=true&lang=css&"
import style1 from "./QCreateSupportTicket.vue?vue&type=style&index=1&id=14d09070&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d09070",
  null
  
)

export default component.exports